const Routes = {
  login: "/login",
  loginCallback: "/login/callback",
  landing: "/",
  home: "/home",
  tokenManagement: "/token-management",
  maintenance: "/maintenance",
  profile: "/profile",
  environments: "/environments",
  staticData: "/static-data",
  clientBuilds: "/client-builds",
  backendImages: "/backend-images",
  serverImages: "/server-images",
  toolboxBuilds: "/toolbox-builds",
  gameConfigEditor: "/game-config-editor",
  dataSchemaEditor: "/data-schema-editor",
  dataStructureEditor: "/data-schema-editor/data-structure-editor",
  managedParameters: "/managed-parameters",
  gameServers: "/game-servers",
  dataEntityEditor: "/data-entity-editor",
  loadTesters: "/load-testers",
  logging: "/logging",
  rulesets: "/matchmaking/rulesets",
  queues: "/matchmaking/queues",
  tickets: "/matchmaking/tickets",
  matches: "/matchmaking/matches",
  cwLogging: "cwlogs",
  integrationTests: "integration-tests",
  gameServerActions: "/game-server-actions",
  backupFull: "/backup/full",
  backupPartial: "/backup/partial",
  artAssetsIdsGenerator: "/art-assets-ids-generator",
  artAssetsIdsBrowser: "/art-assets-ids-browser",
  artAssetsMetadata: "/art-assets-metadata",
  artAssetsIdsRawSheet: "/art-assets-ids-raw-sheet",
  integrationTestConfigurations: "/integration-test-configurations",
  neighborhoods: "/neighborhoods",
  liveOperations: "/live-operations",
  changePlayerData: "/change-player-data",
  workflowsMonitoring: "/workflows-monitoring",
};

export default Routes;
